import { j as C } from "./kezios-design-system.esm172.js";
import { useState as E, useMemo as A, useEffect as c, Children as g, isValidElement as w, cloneElement as f } from "react";
import { useMantineTheme as I } from "@mantine/core";
const a = /([a-zA-Z]+)\.{1}(\d)/gm, j = ({
  size: u,
  color: t,
  gradient: o,
  children: p,
  className: i,
  ...l
}) => {
  const e = I(), [x, s] = E(
    e.colors[e.primaryColor][e.primaryShade]
  ), n = A(() => {
    if (o)
      return o.props.id;
  }, [o]);
  return c(() => {
    if (!t)
      return;
    const r = a.exec(t);
    if (a.lastIndex = 0, r) {
      const [, m, y] = r;
      if (e.colors[m]) {
        s(e.colors[m][parseInt(y)]);
        return;
      }
    }
    if (e.colors[t]) {
      s(e.colors[t][e.primaryShade]);
      return;
    }
    s(t);
  }, [t]), /* @__PURE__ */ C.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      className: i,
      height: `${u / 16}rem`,
      width: `${u / 16}rem`,
      ...l,
      color: x,
      children: [
        p && g.toArray(p).map((r, m) => (typeof r == "string" || typeof r == "number" || Array.isArray(r) || w(r) === !1 || !n || (r.props.fill === "currentColor" && (r = f(r, {
          fill: `url(#${n})`
        })), r.props.stroke === "currentColor" && (r = f(r, {
          stroke: `url(#${n})`
        }))), r)),
        o && o
      ]
    }
  );
};
export {
  j as IconComponent,
  a as MANTINE_COLORS_REGEX
};
